// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"4569cb39","171":"32b8da6f","743":"00dda843"}[chunkId] + ".chunk.js";
};